(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galoi-banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('galoi-banner-slideshow')) {
    class GaloiBannerSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.track = this.querySelector('[data-galoi-track]');
        this.slides = Array.from(this.querySelectorAll('[data-galoi-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-galoi-dot]'));
        this.previousButton = this.querySelector('[data-galoi-previous]');
        this.nextButton = this.querySelector('[data-galoi-next]');
        this.currentIndex = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active')),
        );
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.delay = Math.max(1000, Number(this.dataset.delay || 5) * 1000);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pointerStart = null;
        this.suppressLinkUntil = 0;
        this.isInViewport = true;

        if (!this.track || this.slides.length === 0) return;

        this.previousButton?.addEventListener('click', () => {
          this.show(this.currentIndex - 1, true);
        });

        this.nextButton?.addEventListener('click', () => {
          this.show(this.currentIndex + 1, true);
        });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.show(index, true));
        });

        this.addEventListener('click', (event) => {
          const slideLink = event.target.closest('[data-galoi-slide-link]');
          if (!slideLink || performance.now() >= this.suppressLinkUntil) return;
          event.preventDefault();
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.currentIndex - 1, true);
          if (event.key === 'ArrowRight') this.show(this.currentIndex + 1, true);
        });

        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.pointerStart = { x: event.clientX, y: event.clientY };
        });

        this.track.addEventListener('pointerup', (event) => {
          if (!this.pointerStart) return;

          const deltaX = event.clientX - this.pointerStart.x;
          const deltaY = event.clientY - this.pointerStart.y;
          this.pointerStart = null;

          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY)) return;

          this.suppressLinkUntil = performance.now() + 400;
          this.show(deltaX < 0 ? this.currentIndex + 1 : this.currentIndex - 1, true);
        });

        this.track.addEventListener('pointercancel', () => {
          this.pointerStart = null;
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
        }

        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.startAutoplay();
        });

        this.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-galoi-slide]');
          const selectedIndex = this.slides.indexOf(selectedSlide);

          if (selectedIndex >= 0) {
            this.stopAutoplay();
            this.show(selectedIndex, false);
          }
        });

        this.addEventListener('shopify:block:deselect', () => this.startAutoplay());

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(
            ([entry]) => {
              this.isInViewport = entry.isIntersecting;

              if (entry.isIntersecting) {
                this.playActiveMedia();
                this.startAutoplay();
              } else {
                this.stopAutoplay();
                this.pauseAllMedia();
              }
            },
            { threshold: 0.10 },
          );
          this.visibilityObserver.observe(this);
        } else {
          this.startAutoplay();
        }

        this.show(this.currentIndex, false);
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.pauseAllMedia();
        this.visibilityObserver?.disconnect();
      }

      show(requestedIndex, resetAutoplay = false) {
        const slideCount = this.slides.length;
        if (slideCount === 0) return;

        const normalizedIndex = (requestedIndex + slideCount) % slideCount;
        this.currentIndex = normalizedIndex;

        if (this.classList.contains('galoi-banner-slideshow--slide')) {
          this.track.style.transform = `translate3d(-${normalizedIndex * 100}%, 0, 0)`;
        }

        this.slides.forEach((slide, index) => {
          const isActive = index === normalizedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));

          if (isActive) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');

          slide.querySelectorAll('video').forEach((video) => {
            const isVisibleMedia = video.offsetParent !== null;
            const canPlay = isActive && isVisibleMedia && this.isInViewport;

            if (canPlay) video.play().catch(() => {});
            else video.pause();
          });
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (resetAutoplay) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      pauseAllMedia() {
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      playActiveMedia() {
        const activeSlide = this.slides[this.currentIndex];
        if (!activeSlide || !this.isInViewport) return;

        activeSlide.querySelectorAll('video').forEach((video) => {
          const isVisibleMedia = video.offsetParent !== null;
          if (isVisibleMedia) video.play().catch(() => {});
        });
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.reducedMotion || this.slides.length <= 1 || this.autoplayTimer) return;

        this.autoplayTimer = window.setInterval(() => this.show(this.currentIndex + 1, false), this.delay);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    customElements.define('galoi-banner-slideshow', GaloiBannerSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
